export default [
  {
    path: "builder",
    name: "builder",
    component: () => import("@/views/adminPanel/pages/builder/Builder.vue"),
    meta: {
      rule: "editor",
      authRequired: true,
    },

    children: [
      {
        path: "quality-assurance",
        name: "builder-QA",
        component: () =>
          import(
            "@/views/adminPanel/pages/builder/NewScreen/businessTable/BusinessTable.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "user-experience",
        name: "builder-UX",
        component: () =>
          import(
            "@/views/adminPanel/pages/builder/NewScreen/businessWireframes/BusinessWireframes.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "business-analyst",
        name: "builder-BA",
        component: () =>
          import(
            "@/views/adminPanel/pages/builder/NewScreen/businessRequirments/BusinessRequirments.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "project-manager",
        name: "builder-PM",
        component: () =>
          import(
            "@/views/adminPanel/pages/builder/NewScreen/projectManager/ProjectManager.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "developer-one",
        name: "developer-one",
        component: () =>
          import(
            "@/views/adminPanel/pages/builder/NewScreen/developers/Developer.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "developer-two",
        name: "developer-two",
        component: () =>
          import(
            "@/views/adminPanel/pages/builder/NewScreen/developers2/Developer2.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "developer-three",
        name: "developer-three",
        component: () =>
          import(
            "@/views/adminPanel/pages/builder/NewScreen/developers3/Developer3.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
    ],
  },
  {
    path: "builder/domain",
    name: "domain",
    component: () =>
      import("@/views/adminPanel/pages/builder/NewScreen/domain/Domain.vue"),
    meta: {
      rule: "editor",
      authRequired: true,
    },
  },
  {
    path: "builder/performance-utlilization",
    name: "performance-utlilization",
    component: () =>
      import(
        "@/views/adminPanel/pages/builder/NewScreen/resourceutilization/ResourseUtilization.vue"
      ),
    meta: {
      rule: "editor",
      authRequired: true,
    },
  },
  {
    path: "builder/newscope",
    name: "newscope",
    component: () =>
      import("@/views/adminPanel/pages/builder/components/Newscope.vue"),
    meta: {
      rule: "editor",
      authRequired: true,
    },
  },
  {
    path: "builder/scope",
    name: "builder-scope",
    component: () =>
      import("@/views/adminPanel/pages/builder/components/BuilderScopeReq.vue"),
    meta: {
      rule: "editor",
      authRequired: true,
    },
  },
];
